import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from './auth.service';
import { loginRedirectTo } from './login-redirect';

export const authenticatedGuard: CanActivateFn = (_route, state) =>
  inject(AuthService).isLoggedIn() || loginRedirectTo(inject(Router), state.url);
